import axios from 'axios';
import urlHelper from '../helpers/UrlHelper';
import Swal from "sweetalert2";
import caAPI from "./caAPI";
  
const api = axios.create({
    baseURL: process.env.REACT_APP_CA_API,
    headers: {
        'Authorization': JSON.parse(localStorage.getItem('@DommusCA-token')),
        'X-Gu-Access-Token': urlHelper.getCookie('gu_access_token')
    }
});

let alertaExibido = false;

api.interceptors.response.use(undefined, async (error) => {
  if (error.response?.status === 401) {
    if (alertaExibido) {
      return new Promise(() => {});
    }
    if (error.response?.data === "Acesso não permitido neste horário") {
      if (!alertaExibido) {
        alertaExibido = true;
        await Swal.fire({
          titleText: "Erro",
          text: "Horario não permitido",
          icon: 'error',
          timer: 5000
        });
        caAPI.logout();
        if (window.location.pathname !== '/login') {
          window.location = process.env.REACT_APP_GU_FRONT + '/modulo/logout';
        }
        return new Promise(() => {});
      }
    } else if (error.response?.data === "Token expirado") {
      if (!alertaExibido) {
        alertaExibido = true;
        await Swal.fire({
          titleText: "Sessão expirada",
          text: "O tempo de vida da sua sessão acabou. Faça login no módulo novamente.",
          icon: 'warning',
          timer: 5000
        });
        caAPI.logout();
        if (window.location.pathname !== '/login') {
          window.location = process.env.REACT_APP_GU_FRONT + '/modulo/logout';
        }
        return new Promise(() => {}); 
      }
    }
  }
  throw error;
});


export default api;
